import React, { useState } from 'react';
import _, { isEmpty } from 'lodash';
import { makeStyles } from 'tss-react/mui';
import { Grid } from '@mui/material';
import Button from '../../../components/Button';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import 'react-phone-number-input/style.css';
import styles from '../../../EditDevice/editDevice.styles.js';
import inputValidation from '../../../input-validation.service';
import { toast } from 'react-toastify';
import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import PhoneInput from '../../../components/PhoneInput.jsx';
import useStore from '../../../Store/Store.js';
import IconButton from '../../../components/IconButton.jsx';
import TextInput from '../../../components/TextInput.jsx';

// custom hook

import { useUserLocation } from '../../../hooks/useUserLocation.js';
const useStyles = makeStyles()(styles);

function AddCaregivers({ user, refresh, closeModal, recipient = false }) {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const [searchByPhone, setSearchByPhone] = useState(true);
  const { country } = useUserLocation();
  const [state, setState] = useState({
    isFound: null,
    searchBar: '',
    errorMessage: '',
  });
  const selectedRecipient = useStore((state) => state.selectedRecipient);
  const handleCheckCaregiver = async (e) => {
    e.preventDefault();
    const { searchBar } = state;

    if (isEmpty(searchBar)) {
      setState((prev) => {
        return { ...prev, errorMessage: t('pleaseFillAllFields') };
      });
      return;
    }

    if (!inputValidation.email(searchBar) && !inputValidation.validatePhoneNumber(searchBar)) {
      setState((prev) => {
        return { ...prev, errorMessage: t('invalidEmailOrPhone') };
      });
      return;
    }

    try {
      if (isEmpty(selectedRecipient)) {
        await axios.post(
          process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${user?._id}/checkCaregiver`,
          { searchBar },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      } else {
        await axios.post(
          process.env.REACT_APP_EXPRESS_URL + `/api/canCare/caregiver/${user?._id}/checkUserCaregiver`,
          { searchBar, mainUserId: selectedRecipient },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      }
      setState((prev) => {
        return { ...prev, isFound: true, errorMessage: '' };
      });
    } catch (error) {
      if (error?.response?.status === 404) {
        setState((prev) => {
          return { ...prev, isFound: false, errorMessage: '' };
        });
        return;
      }
      setState((prevState) => {
        return {
          ...prevState,
          errorMessage: error.response.data.message || t('somethingWentWrong'),
        };
      });
    }
  };

  const handleAddCaregiver = async (e) => {
    const { searchBar } = state;

    if (isEmpty(searchBar)) {
      setState((prev) => {
        return { ...prev, errorMessage: t('pleaseFillAllFields') };
      });
      return;
    }

    let email = '';
    let phoneNo = '';

    if (inputValidation.email(searchBar)) email = searchBar;
    if (inputValidation.validatePhoneNumber(searchBar)) phoneNo = searchBar;

    try {
      setLoader(true);
      if (isEmpty(selectedRecipient)) {
        await axios.post(
          process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${user?._id}/inviteCaregiver`,
          { email, phoneNo },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      } else {
        await axios.post(
          process.env.REACT_APP_EXPRESS_URL +
            `/api/canCare/caregiver/${user?._id}/inviteOtherCaregiver/${selectedRecipient}`,
          { email, phoneNo },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      }
      refresh();
      toast(t(recipient ? 'recipientInvited' : 'caregiverInvited'));
      closeModal();
      setState({ isFound: null, searchBar: '', errorMessage: '' });
    } catch (error) {
      setState((prevState) => {
        return {
          ...prevState,
          errorMessage: error?.response?.data?.message || t('somethingWentWrong'),
        };
      });
    } finally {
      setLoader(false);
    }
  };

  const handleAddRecipient = async () => {
    const { searchBar } = state;

    if (isEmpty(searchBar)) {
      setState((prev) => {
        return { ...prev, errorMessage: t('pleaseFillAllFields') };
      });
      return;
    }

    let email = '';
    let phoneNo = '';

    if (inputValidation.email(searchBar)) email = searchBar;
    if (inputValidation.validatePhoneNumber(searchBar)) phoneNo = searchBar;

    try {
      setLoader(true);
      await axios.post(
        process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${user?._id}/inviteRecipient`,
        { email, phoneNo },
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: localStorage.getItem('auth'),
          },
        },
      );
      refresh();
      toast(t('recipientInvited'));
      closeModal();
      setState({ isFound: null, searchBar: '', errorMessage: '' });
    } catch (error) {
      setState((prevState) => {
        return {
          ...prevState,
          errorMessage: error?.response?.data?.message || t('somethingWentWrong'),
        };
      });
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className={classes.paper}>
      <Grid container item direction="row" justify="space-between" alignItems="center" className={classes.header}>
        <Grid item className={classes.title}>
          {t('invite')} {recipient ? t('recipient') : t('caregivers')}
        </Grid>
        <IconButton icon={<CloseIcon />} onClick={closeModal} />
      </Grid>
      <div
        style={{
          marginTop: '40px',
          display: 'flex',
          borderRadius: '50px',
          width: '180px',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: '#f5f5f7',
          padding: '3px',
          fontSize: '13px',
        }}
      >
        <div
          style={{
            paddingInline: '15px',
            paddingBlock: '10px',
            borderRadius: '50px',
            cursor: 'pointer',
            background: searchByPhone ? '#fff' : 'inherit',
            fontWeight: searchByPhone ? 'bold' : 'normal',
          }}
          onClick={() => setSearchByPhone(true)}
        >
          {t('byPhone')}
        </div>
        <div
          style={{
            paddingInline: '15px',
            paddingBlock: '10px',
            borderRadius: '50px',
            cursor: 'pointer',
            background: !searchByPhone ? '#fff' : 'inherit',
            fontWeight: !searchByPhone ? 'bold' : 'normal',
          }}
          onClick={() => setSearchByPhone(false)}
        >
          {t('byEmail')}
        </div>
      </div>
      <Grid
        container
        item
        direction="column"
        justify="flex-start"
        alignItems="center"
        className={classes.mainContainer}
        style={{ marginTop: '30px' }}
      >
        {!searchByPhone && (
          <Grid item className={classes.userInfoPanel}>
            <div className={classes.newCaregiver}>
              <div className={classes.caregiverErrorMessage}>{state.caregiverErrorMessage}</div>
              <TextInput
                style={{ width: '300px' }}
                label={t('email')}
                value={state.searchBar}
                onChange={(e) => setState((prevState) => ({ ...prevState, searchBar: e.target.value, isFound: null }))}
              />
            </div>
          </Grid>
        )}
        {searchByPhone && (
          <PhoneInput
            style={{ width: '300px' }}
            defaultCountry={country}
            value={state.searchBar}
            placeholder={t('enterPhoneNumber')}
            onChange={(value) => setState((prevState) => ({ ...prevState, searchBar: value, isFound: null }))}
          />
        )}
        <Grid item className={classes.userInfoPanel} style={{ marginTop: '20px' }}>
          {state.isFound === true && (
            <Button
              onClick={() => (recipient ? handleAddRecipient() : handleAddCaregiver())}
              loading={loader}
              text={recipient ? t('addRecipient') : t('addCaregiver')}
            />
          )}
          {state.isFound === false && (
            <Button
              text={recipient ? t('inviteRecipient') : t('inviteCaregiver')}
              onClick={() => (recipient ? handleAddRecipient() : handleAddCaregiver())}
              loading={loader}
            />
          )}
        </Grid>
      </Grid>
      <Grid
        item
        direction="column"
        justify="flex-start"
        alignItems="center"
        className={classes.errorMessage}
        style={{ color: 'red', marginTop: '10px' }}
      >
        {state.errorMessage}
      </Grid>
      <div style={{ marginBlock: '20px', borderBottom: '0.5px solid grey' }} />
      <Grid
        container
        item
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={classes.footer}
      >
        <Grid item style={{ marginRight: '10px' }}>
          <Button text={t('cancel')} onClick={closeModal} bg="light" />
        </Grid>
        <Grid item>
          <Button text={t('invite')} onClick={handleCheckCaregiver} />
        </Grid>
      </Grid>
    </div>
  );
}

export default AddCaregivers;
